import styled from "styled-components";
import { Collapse } from "../atoms/Collapse";

type Props = {
  question: string;
  answer: string;
};

export const FAQItem: React.FC<Props> = ({ question, answer }) => {
  return (
    <FAQItemContainer>
      <Collapse text={question} content={answer} />
    </FAQItemContainer>
  );
};

const FAQItemContainer = styled.div``;
